import { axios_helper_async } from "helpers/Axios";
import withMessages from "Common/withMessages";
import withNotifications, { WithNotificationsProps } from "Common/withNotifications";
import withOverlay, { WithOverlayProps } from "Common/withOverlay";
import React, { useEffect, useState } from "react";
import { WithMessagesProps } from '../../Common/withMessages';
import { WithTranslationProps } from "Common/Components/Translation/WithTranslationProps";
import withTranslation from "Common/withTranslation";
import withRouter, { WithRouterProps } from "Common/withRouter";
import CardProduct from "Common/Components/Card/Products/CardProdcut";
import FilterList from "Common/Components/Filters/FilterList";
import { FilterListElement } from "Common/Components/Filters/FilterListElements";
// import { ProductDetails } from "Common/Models/ProductDetails";
import PriceSlider from "Common/Components/PriceSlider/PriceSlider";
import LoadingOverlay from "Common/Components/LoadingOverlay/LoadingOverlay";
import { NotificationType } from "Common/Components/Notifications/notificationTypes";
import Title from "Common/Components/Titles/Title";
import i18n from "Common/Components/Translation/i18n";
import { WithCurrencyProps } from "Common/Components/Currency/WithCurrencyProps";
import { withCurrency } from "Common/Components/Currency/withCurrency";
import { Product } from "Common/Models/Products";
import { ProductDetails } from "Common/Models/ProductDetails";


const ProductsPage: React.FC<WithMessagesProps & WithNotificationsProps & WithOverlayProps & WithTranslationProps & WithRouterProps & WithCurrencyProps> = ({ messages, notifications, overlay, t, router, c, currency }) => {    
    const [products, setProducts] = useState<ProductDetails[]>([]);
    const [productsFiltered, setProductsFiltered] = useState<ProductDetails[]>([]);
    const [brandsFileterElements, setBrandsFilterElements] = useState<FilterListElement[]>([]);
    const [selectedBrandsFilter, setSelectedBrandsFilter] = useState<number[]>([]);
    const [selectedBrandsFilterNames, setSelectedBrandsFilterNames] = useState<string[]>([]);
    const [minValuePrice, setMinValuePrice] = useState<number>(0);
    const [maxValuePrice, setMaxValuePrice] = useState<number>(0);
    const [minPrice1, setMinPrice1] = useState<number>(0);
    const [minPrice2, setMinPrice2] = useState<number>(0);
    const [maxPrice1, setMaxPrice1] = useState<number>(0);
    const [maxPrice2, setMaxPrice2] = useState<number>(0);
    const [onlyAvailableProdcuts, setOnlyAvailableProducts] = useState<boolean>(false);
    const [orderBy, setOrderBy] = useState<number>(0);
    const orderByTitles = ["Products.OrderBySelectOptions.Select", "Products.OrderBySelectOptions.NameAZ", "Products.OrderBySelectOptions.NameZA", "Products.OrderBySelectOptions.MaxPrice", "Products.OrderBySelectOptions.MinPrice"];
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [categoryId, setCategoryId] = useState<number>(-1);
    const [categoryName, setCategoryName] = useState<string>("");

    const GetProducts = async () => {
        try {
            setIsLoading(true);
            if(categoryId > -1) {
                const body = {
                    language: i18n.language,
                    categoryId: categoryId
                }
                let response = await axios_helper_async<ProductDetails[]>('/SOI/Get-Products-Details-By-Category', 'GET', body);
    
                messages.setMessages(response.messages);
                notifications.setNotifications(response.notifications);

                if (response.isSuccess && response.data) {
                    setProducts(response.data);
                }
            }
        }
        catch (err: any) {
            notifications.showNotification(err, NotificationType.Error);
        }
        finally {
            setIsLoading(false);
        }
    };

    const GetCategoryName = async (lng: string) => {
        try {            
            const body = {
                language: lng,
                categoryId: categoryId
            }

            let response = await axios_helper_async<string>('/SOI/Get-Category-Name-By-Id', 'GET', body);

            messages.setMessages(response.messages);
            notifications.setNotifications(response.notifications);

            if (response.isSuccess && response.data) {
                setCategoryName(response.data);
            }
        }
        catch (err: any) {
            notifications.showNotification(err, NotificationType.Error);
        }
        finally {            
        }
    };

    const handleMinPriceChange = (value: number) => {
        setMinValuePrice(value);
    }

    const handleMaxPriceChange = (value: number) => {
        setMaxValuePrice(Number(value));
    }

    const handleOnlyAvailableChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { checked } = e.target;

        setOnlyAvailableProducts(checked);
    }

    const hanldeOrderByChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const { value } = e.target;

        setOrderBy(Number(value));
    }

    const handleBrandFilter = (index: number) => {
        if (selectedBrandsFilter.some(x => x === index)) {
            setSelectedBrandsFilter(selectedBrandsFilter.filter(x => x !== index));
            setSelectedBrandsFilterNames(selectedBrandsFilterNames.filter(x => x !== brandsFileterElements.find(x => x.id === index)?.element1));
        }
        else {
            setSelectedBrandsFilter([...selectedBrandsFilter, index]);
            setSelectedBrandsFilterNames([...selectedBrandsFilterNames, brandsFileterElements.find(x => x.id === index)?.element1]);
        }
    }

    const setBrandFilters = () => {
        let index: number = 1;
        const newBrandsFileterElements: FilterListElement[] = [];
        products.map((product) => {
            if (!newBrandsFileterElements.some(x => x.element1 === product.brand)) {
                const total: number = productsFiltered.filter(x => x.brand === product.brand).reduce((sum, x) => sum + x.quantity, 0);
                const newElement: FilterListElement = {
                    element1: product.brand,
                    element2: total,
                    id: index
                }
                newBrandsFileterElements.push(newElement)
            }
            index++;
        });
        setBrandsFilterElements(newBrandsFileterElements);
    }

    const resetBrandsFilter = () => {
        setSelectedBrandsFilter([]);
        setSelectedBrandsFilterNames([]);
    }

    const resetPriceFilter = () => {
        setMinValuePrice(minPrice1);
        setMaxValuePrice(maxPrice2);
    }

    const resetOtherFilters = () => {
        setOnlyAvailableProducts(false);
        setOrderBy(0);
    }

    const getPriceValues = () => {
        let minValue = 0;
        let maxValue = 0;

        for (var i = 0; i < products.length; i++) {
            if (i === 0) {
                minValue = products[i].price;
                maxValue = products[i].price;
            }
            else {
                if (minValue > products[i].price) {
                    minValue = products[i].price;
                }
                if (maxValue < products[i].price) {
                    maxValue = products[i].price;
                }
            }
        }

        setMinPrice1(minValue);
        setMinPrice2(minValue);
        setMaxPrice1(maxValue);
        setMaxPrice2(maxValue);
        setMinValuePrice(minValue);
        setMaxValuePrice(maxValue);
    }

    useEffect(() => {
        if (products.length > 0) {
            setBrandFilters();
            getPriceValues();
        }
    }, [products])

    useEffect(() => {
        let newList = products.filter(product => (product.price <= maxValuePrice && product.price >= minValuePrice) && (onlyAvailableProdcuts ? product.quantity > 0 : true) && (selectedBrandsFilterNames.length === 0 ? true : selectedBrandsFilterNames.some(x => x === product.brand)));
        switch (orderBy) {
            case 1:
                newList = newList.sort((a, b) => a.name.localeCompare(b.name));
                break;
            case 2:
                newList = newList.sort((a, b) => b.name.localeCompare(a.name));
                break;
            case 3:
                newList = newList.sort((a, b) => b.price - a.price);
                break;
            case 4:
                newList = newList.sort((a, b) => a.price - b.price);
                break;

        }

        setProductsFiltered(newList);
    }, [minValuePrice, maxValuePrice, onlyAvailableProdcuts, orderBy, selectedBrandsFilterNames])

    useEffect(() => {
        if (minPrice2 < minValuePrice) {
            setMinPrice2(minValuePrice);
            if (maxValuePrice < minValuePrice) {
                setMaxValuePrice(minValuePrice);
            }
        }
        else {
            setMinPrice2(minValuePrice);
        }
        if (maxPrice1 > maxValuePrice) {
            setMaxPrice1(maxValuePrice);
            if (minValuePrice > maxValuePrice) {
                setMinValuePrice(maxValuePrice);
            }
        }
        else {
            setMaxPrice1(maxValuePrice);
        }        
    }, [minValuePrice, maxValuePrice]);

    useEffect(() => {
        if (products.length > 0 && (maxValuePrice !== 0 && minValuePrice !== 0)) {
            //setBrandFilters();
        }
    }, [products, minValuePrice, maxValuePrice])

    useEffect(() => {
        const id = router.queryParams.get('category');        
        if(id) setCategoryId(Number(id));
        i18n.on("languageChanged", GetCategoryName);        

        return () => {
            i18n.off("languageChanged", GetCategoryName);
        };
    }, []);

    useEffect(() => {
        if(categoryId > -1) {
            (async () => {
                await GetProducts();
                await GetCategoryName(i18n.language);
            })();
        }
    }, [categoryId]);

    return (
        <React.Fragment>
            <div className="relative flex flex-col gap-3">
                {isLoading ?
                    <LoadingOverlay />                    
                :                 
                    <>
                        <Title text={t('General.Products')} />
                        {categoryName && <h3 className="text-center">{t('General.Category')}: {categoryName}</h3>}
                        {products.length > 0 && <div className="flex flex-col md:flex-row justify-start items-start w-full gap-2 border border-gray-400 rounded-md p-2">
                            <div className="flex flex-col justify-center items-center gap-2 w-full md:w-1/3">
                                <FilterList
                                    className="w-full"
                                    columnName1={t('Products.BrandsFilterTitle')}
                                    columnName2={t('Products.QuantityFilterTitle')}
                                    elements={brandsFileterElements}
                                    selectedElements={selectedBrandsFilter}
                                    onClick={handleBrandFilter}
                                />
                                {selectedBrandsFilter.length > 0 && <span className="w-fill form-reset-filter" onClick={resetBrandsFilter}>{t('Products.ResetFilter')}</span>}
                            </div>
                            <div className="flex flex-col gap-2 justify-center items-stretch w-full md:w-1/3">
                                <PriceSlider
                                    min={minPrice1}
                                    max={maxPrice1}
                                    value={minValuePrice}
                                    title={t("Products.MinPriceTitle")}
                                    onChange={handleMinPriceChange}
                                />
                                <PriceSlider
                                    min={minPrice2}
                                    max={maxPrice2}
                                    value={maxValuePrice}
                                    title={t("Products.MaxPriceTitle")}
                                    onChange={handleMaxPriceChange}                                    
                                />
                                {(minValuePrice > minPrice1 || maxValuePrice < maxPrice2) && <span className="w-fill form-reset-filter" onClick={resetPriceFilter}>{t('Products.ResetFilter')}</span>}
                            </div>
                            <div className="flex flex-col gap-3 justify-center items-center w-full md:w-1/3">
                                <label className="form-label">{t('Products.FilterByTitle')}:</label>
                                <div className="flex items-center gap-2">
                                    <input id="checkboxOnlyAvailable" className="w-4 h-4 border rounded-sm appearance-none cursor-pointer bg-slate-100 border-slate-200 dark:bg-zink-600 dark:border-zink-500 checked:bg-custom-500 checked:border-custom-500 dark:checked:bg-custom-500 dark:checked:border-custom-500 checked:disabled:bg-custom-400 checked:disabled:border-custom-400" type="checkbox" checked={onlyAvailableProdcuts} onChange={handleOnlyAvailableChange} />
                                    <label htmlFor="checkboxOnlyAvailable" className="align-middle">
                                        {t('Products.StockTitle')}
                                    </label>
                                </div>
                                <label className="form-label">{t('Products.OrderByTitle')}:</label>
                                <div>
                                    <select id="orderBy" className="form-select" onChange={hanldeOrderByChange} value={orderBy}>
                                        {orderByTitles.map((value, index) => {
                                            return (
                                                <option key={index} value={index}>{t(value)}</option>
                                            );
                                        })}
                                    </select>
                                </div>
                                {(onlyAvailableProdcuts || orderBy > 0) && <span className="w-fill form-reset-filter" onClick={resetOtherFilters}>{t('Products.ResetFilter')}</span>}
                            </div>
                        </div>}
                        <div className="flex flex-row justify-start items-start w-full gap-2">
                            <div className="grid gap-2 w-full">
                                <div className="grid grid-cols-2 md:grid-cols-6 gap-1">
                                    {productsFiltered.map((product, index) => {
                                        return (
                                            <CardProduct
                                                key={index}
                                                brand={product.brand}
                                                img={product.image}
                                                name={product.name}
                                                sku={product.sku}
                                                price={c(product.price)}
                                                // currency={product.currency}
                                                quantity={product.quantity}
                                                width={150}
                                                height={150}
                                                link={`/Product?category=${categoryId}&product=${product.id}`}
                                            />
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </>
                }
            </div>
        </React.Fragment>
    );
}

export default withTranslation(withNotifications(withMessages(withOverlay(withRouter(withCurrency(ProductsPage))))));